/*
 * fiore-pdp.js (v2.1 — Dawn + Impulse)
 * Re-filters the Fiore editorial & campaign sections to the active colour, and
 * on Impulse (Bonoboss) also filters the MAIN product gallery (Flickity
 * slideshow + thumbnails) to the active colour.
 *
 * Colour resolution: variant id -> colour code via the JSON map printed by
 * snippets/fiore-color-map.liquid (#fiore-vcmap). Media matching: filename
 * contains -cN- (slug-driven; never depends on alt text).
 *
 * Impulse gallery strategy: cache ALL Flickity cells once, then rebuild the
 * carousel with only the active colour's cells (remove/insert). Thumbnails are
 * shown/hidden by the same filename rule; thumb clicks are re-bound in capture
 * phase to selectCell('[data-index="N"]') so original indexes keep working
 * after filtering. Images without a -cN- token are treated as colour-agnostic
 * and always shown. On Dawn (no .product-slideshow) the gallery code no-ops.
 *
 * v2.2 (30-Ago-2026): the Impulse gallery takeover now BAILS entirely when the
 * PDP uses the theme's native image sets (#color_ alts -> data-group slides).
 * The native system destroys/recreates Flickity per colour, so our cached
 * instance goes stale and remove/insert on it DELETED the initial colour's
 * cells from the DOM (return to the loading colour showed 0 photos). With the
 * guard, gallery + thumbs are 100% native there; applySections keeps working.
 */
(function () {
  if (window.__fioreInit) return;
  window.__fioreInit = true;

  var COLOR_RE = /-(c\d+)(?=[-.])/;

  function readMap() {
    var el = document.getElementById('fiore-vcmap');
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
  }
  var map = readMap();

  function currentVariantId() {
    var input = document.querySelector(
      'product-info form [name="id"], product-form form [name="id"], form[action*="/cart/add"] [name="id"]'
    );
    if (input && input.value) return String(input.value);
    var u = new URLSearchParams(window.location.search).get('variant');
    return u ? String(u) : null;
  }

  function currentColor() {
    var id = currentVariantId();
    if (id && map[id]) return map[id];
    var first = document.querySelector('[data-fiore-color]');
    return first ? first.getAttribute('data-fiore-color') : null;
  }

  function colorOf(url) {
    if (!url) return null;
    var m = String(url).match(COLOR_RE);
    return m ? m[1] : null;
  }

  /* ---------- Fiore sections (Dawn + Impulse) ---------- */
  function applySections(code) {
    var groups = document.querySelectorAll('[data-fiore-color]');
    for (var i = 0; i < groups.length; i++) {
      var on = groups[i].getAttribute('data-fiore-color') === code;
      groups[i].hidden = !on;
      groups[i].setAttribute('aria-hidden', on ? 'false' : 'true');
    }
    var sections = document.querySelectorAll('[data-fiore-section]');
    for (var s = 0; s < sections.length; s++) {
      var active = sections[s].querySelector('[data-fiore-color="' + code + '"]');
      var count = active ? active.querySelectorAll('.fiore-media, .fiore-cmp__media').length : 0;
      sections[s].hidden = count === 0;
    }
  }

  /* ---------- Impulse main gallery (no-op elsewhere) ---------- */
  var flkty = null;
  var allCells = null;      // master list, original order
  var cellColor = null;     // data-index -> colour code (null = agnostic)
  var thumbsBound = false;

  function galleryInit() {
    // FIX 30-Ago-2026: si el PDP usa el sistema NATIVO de image sets de Impulse
    // (alts #color_ -> data-group en las slides), el theme es dueno de la galeria:
    // destruye y recrea Flickity en cada cambio de color, dejando stale nuestro
    // cache (flkty/allCells). Un remove/insert sobre esa instancia muerta BORRA
    // del DOM las celdas del color inicial (bug: volver al color de carga = 0 fotos).
    // Guard permanente: galeria y thumbs 100% nativos; applySections sigue viva.
    if (document.querySelector('.product-main-slide[data-group]')) return false;
    if (allCells) return true;
    if (typeof window.Flickity === 'undefined') return false;
    var el = document.querySelector('.product-slideshow');
    if (!el) return false;
    flkty = window.Flickity.data(el);
    if (!flkty) return false;
    allCells = flkty.getCellElements();
    cellColor = {};
    // Colour per original index, resolved from the thumbnail hrefs (they carry
    // the CDN filename; main slides may lazy-load without a usable src yet).
    document.querySelectorAll('.product__thumb-item').forEach(function (t) {
      var a = t.querySelector('a[href]');
      var idx = t.getAttribute('data-index');
      if (idx != null) cellColor[idx] = colorOf(a && a.getAttribute('href'));
    });
    // Fallback: read from any img inside each cell.
    allCells.forEach(function (c) {
      var idx = c.getAttribute('data-index');
      if (cellColor[idx] === undefined) {
        var img = c.querySelector('img');
        cellColor[idx] = colorOf(img && (img.currentSrc || img.src || img.getAttribute('data-src')));
      }
    });
    // Thumb clicks: select by original data-index (survives filtering).
    if (!thumbsBound) {
      thumbsBound = true;
      document.addEventListener('click', function (e) {
        var a = e.target && e.target.closest && e.target.closest('.product__thumb-item a');
        if (!a || !flkty) return;
        var item = a.closest('.product__thumb-item');
        var idx = item && item.getAttribute('data-index');
        if (idx == null) return;
        e.preventDefault();
        e.stopPropagation();
        try { flkty.selectCell('[data-index="' + idx + '"]', false, false); } catch (err) {}
      }, true);
    }
    return true;
  }

  var galleryLast = null;
  function filterThumbs(code) {
    document.querySelectorAll('.product__thumb-item').forEach(function (t) {
      var col = cellColor[t.getAttribute('data-index')];
      t.style.display = (!col || col === code) ? '' : 'none';
    });
  }
  function applyGallery(code) {
    if (!galleryInit()) return;
    if (code === galleryLast) return;
    galleryLast = code;
    // Thumbnails FIRST — pure DOM, must never be skipped by a Flickity throw
    // (Impulse listeners run synchronously inside select() and can raise).
    filterThumbs(code);
    var keep = allCells.filter(function (c) {
      var col = cellColor[c.getAttribute('data-index')];
      return !col || col === code;   // agnostic images always shown
    });
    if (!keep.length) return;        // never leave the carousel empty
    try { flkty.remove(flkty.getCellElements()); } catch (e) {}
    try { flkty.insert(keep, 0); } catch (e) {}
    try { flkty.select(0, false, true); } catch (e) {}
    try { flkty.resize(); } catch (e) {}
    // Re-assert after Impulse's own variant handlers settle.
    setTimeout(function () { filterThumbs(code); }, 120);
  }

  function apply(code) {
    if (!code) return;
    applySections(code);
    applyGallery(code);
  }

  var last = null;
  function sync() {
    var c = currentColor();
    if (c && c !== last) { last = c; apply(c); }
  }

  function boot() { sync(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('change', function () { setTimeout(sync, 0); }, true);
  document.addEventListener('click', function () { setTimeout(sync, 0); }, true);
  document.addEventListener('variant:change', function () { setTimeout(sync, 0); });
  window.addEventListener('popstate', function () { setTimeout(sync, 0); });
  setInterval(sync, 500);
})();
